import isUrl from '../../node_modules/is-url/index.js';
export { SPOTIFY_URL_REGEX, TWITTER_URL_REGEX, VIMEO_URL_REGEX } from './regex.js';

const isUrlWithProtocol = (url) => {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol) return isUrl(url);
  } catch {
  }
  return isUrl(`https://${url}`);
};
const formatUrlWithProtocol = (url) => {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol) return url;
  } catch {
  }
  return `https://${url}`;
};
const protocolRegex = new RegExp(/^.+?:\/\//);
const cleanUrl = (href, options) => {
  try {
    const url = new URL(href);
    const fragments = [url.hostname.replace("www.", ""), url.pathname !== "/" ? url.pathname : ""];
    if (options?.includeSearch) {
      fragments.push(url.search);
    }
    return fragments.join("");
  } catch {
    return href.replace(protocolRegex, "").replace(/\/$/, "").replace("www.", "");
  }
};

export { cleanUrl, formatUrlWithProtocol, isUrlWithProtocol };
//# sourceMappingURL=index.js.map
